export default __webpack_public_path__ + "static/media/6.fe312106.png";